<div class="schema-wrapper" [ngClass]="[
        activeButton === SchemaButton.LEFT ? 'left-button-active' : '',
        activeButton === SchemaButton.MIDDLE ? 'middle-button-active' : '',
        activeButton === SchemaButton.RIGHT ? 'right-button-active' : ''
    ]">
  <button (click)="handleSchemaButtonClick(SchemaButton.PRIMARY)" class="primary-button" [ngClass]="activeButton === SchemaButton.PRIMARY ? 'active' : ''">Healthy, Wealthy and Wise

    <svg class="primary-button-arrows" width="210" height="60" viewBox="0 0 294 77" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M285.5 75.5C285.5 65.5 285.5 46.2 285.5 43C285.5 39.8 282.833 39 281.5 39H12.5C11.1667 39 8.5 39.8 8.5 43V75.5M285.5 75.5L278 68M285.5 75.5L293 68M146 6V75.5M146 75.5L138.5 68M146 75.5L153.5 68M8.5 75.5L1 68M8.5 75.5L16 68" stroke="#A3A3A3" stroke-linecap="round"/>
      <circle cx="146" cy="6" r="6" fill="#A3A3A3"/>
      <circle cx="146" cy="6" r="4" fill="white"/>
    </svg>

  </button>

  <div class="secondary-buttons-wrapper">

    <button class="secondary-button" (click)="handleSchemaButtonClick(SchemaButton.LEFT)" [ngClass]="activeButton === SchemaButton.LEFT ? 'active' : ''">Health <br>Index

      <svg class="left-button-arrows" width="100%" height="500%" viewBox="0 0 77 320" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 6V308C6 309.333 6.8 312 10 312H75.5M6 55H75.5M75.5 55L68 62.5M75.5 55L68 47.5M6 118.5H75.5M75.5 118.5L68 126M75.5 118.5L68 111M6 182H75.5M75.5 182L68 189.5M75.5 182L68 174.5M6 247H75.5M75.5 247L68 254.5M75.5 247L68 239.5M75.5 312L68 319.5M75.5 312L68 304.5" stroke="#A3A3A3" stroke-linecap="round"/>
        <circle cx="6" cy="6" r="6" fill="#A3A3A3"/>
        <circle cx="6" cy="6" r="4" fill="white"/>
      </svg>


    </button>

    <button class="secondary-button" (click)="handleSchemaButtonClick(SchemaButton.MIDDLE)" [ngClass]="activeButton === SchemaButton.MIDDLE? 'active' : ''">Wealth <br>Index

      <svg class="middle-button-arrows" width="200%" height="500%" viewBox="0 0 146 322" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 56H70.5M70.5 56L63 63.5M70.5 56L63 48.5M1 119.5H70.5M70.5 119.5L63 127M70.5 119.5L63 112M1 183H70.5M70.5 183L63 190.5M70.5 183L63 175.5M70.5 314L63 321.5M70.5 314L63 306.5M70.5 314H5C3.66667 314 1 313.2 1 310V24.5C1 20.1 4.33333 19.3333 6 19.5H136C139.6 19.5 140.5 16.5 140.5 15V11.5M1 249H70.5M70.5 249L63 256.5M70.5 249L63 241.5" stroke="#A3A3A3" stroke-linecap="round"/>
        <circle cx="140" cy="6" r="6" fill="#A3A3A3"/>
        <circle cx="140" cy="6" r="4" fill="white"/>
      </svg>


    </button>

    <button class="secondary-button" (click)="handleSchemaButtonClick(SchemaButton.RIGHT)" [ngClass]="activeButton === SchemaButton.RIGHT ? 'active' : ''">Wisdom <br>Index

      <svg class="right-button-arrows" width="60" height="530%" viewBox="0 0 89.48 315" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="-58" cy="-3" r="6" transform="matrix(-1 0 0 1 12.5 0)" fill="#A3A3A3"/>
        <circle cx="-60" cy="-5" r="4" transform="matrix(-1 0 0 1 10.5 2)" fill="white"/>
        <path d="M70.5 1V239.5C70.5 240.833 69.7 243.5 66.5 243.5H1M70.5 50H1M1 50L8.5 57.5M1 50L8.5 42.5M70.5 113.5H1M1 113.5L8.5 121M1 113.5L8.5 106M70.5 177H1M1 177L8.5 184.5M1 177L8.5 169.5M1 243.5L8.5 251M1 243.5L8.5 236" stroke="#A3A3A3" stroke-linecap="round"/>
      </svg>
    </button>

  </div>


  <div class="tertiary-buttons-wrapper" [ngClass]="activeButton === SchemaButton.RIGHT ? 'right-button-active' : ''">
    <ng-container *ngFor="let button of buttonsArr">
      <button class="tertiary-button" (click)="handleTertiaryButtonClick(button)" [ngClass]="activeTertiaryButtons.includes(button) ? 'active': '' ">{{button}}</button>
    </ng-container>
  </div>

</div>
